import React, {Fragment, PropsWithChildren} from 'react';
import {useRouteMatch} from 'react-router-dom';
import SignContractContainer from 'js/application/components/signContract/container';

type RouteMatch = {
	hash: string
}

function EContractSignatureWrapper({children}: PropsWithChildren) {
	const match = useRouteMatch<RouteMatch>({path: '/econtract/:hash', exact: false});

	if (match && match.params && match.params.hash) {
		return <SignContractContainer eContractHash={match.params.hash} />;
	}
	
	return (
		<Fragment>
			{children}
		</Fragment>
	);
}

export default EContractSignatureWrapper;
